export default __webpack_public_path__ + "static/media/Márcio Douglas_.72e42743.png";